export default "__VITE_ASSET__Do8hHswM__"